// Test dealers for development and testing
// These will only be shown for user 'Nick-Largent'

export const TEST_DEALERS = [
  {
    id: "MP1500",
    name: "Drive Smart (vAuto only)",
    description: "vAuto dealer with no Common Org Id"
  },
  {
    id: "MP10953",
    name: "Ferman Ford of Clearwater (All solutions)",
    description: "Dealership with all connected solutions"
  },
  {
    id: "e9b4e7c6-f7de-400e-b0a6-692d92b2ecd3",
    name: "MY 1ST RATE AUTO (no vAuto)",
    description: "OnRamp dealer with no vAuto data. HomeNet not mapped correctly. Use VRT 2394869"
  },
  {
    id: "MP2030",
    name: "Egolf Motors (Miss-mapped vAuto)",
    description: "vAuto mapped to wrong platfrom Id"
  },
  {
    id: "dceb4ba7-cfdb-4b7a-95b3-0db7d9850f72",
    name: "MCDANIELS AUTO GROUP (no vAuto or CVI)",
    description: "DDC & VIN only. No data in vAuto or CVI"
  }
];
